/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-11-29
 * @brief EHP 도움말 - utils 개발
 *
 ********************************************************************/
import React from "react";
/**
 * @brief EHP 도움말 - utils  컴포넌트
 * @param
 * @returns react components
 */
export const HelpUtil = [
    //   111   //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        "id": 1,
        "mname": "Login Page",
        "subMenu": [
            {
                sid: 1,
                sname: "회원 가입",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uD68C\uC6D0\uAC00\uC785\uC744 \uD074\uB9AD\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/1.Login/1-1-1.png`)
                    },
                    {
                        order: 2,
                        //circledDigit: <span style={{ color: "red" }}>{"\u2461"}</span>,
                        procedure: React.createElement("span", null,
                            "\uD68C\uC6D0\uAC00\uC785 \uC591\uC2DD\uC5D0 \uB530\uB77C \uAC00\uC785 \uC815\uBCF4\uB97C \uC791\uC131 \uD6C4 ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uAC00\uC785\uC744 \uD074\uB9AD\uD569\uB2C8\uB2E4(",
                            React.createElement("span", { style: { color: "red" } }, "*"),
                            " \uD45C\uC2DC\uB41C \uBD80\uBD84\uC740 \uBC18\uB4DC\uC2DC \uC791\uC131)."),
                        captureImg: require(`/static/img/img_help/1.Login/1-1-2.png`)
                    },
                    {
                        order: 3,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC778\uC99D\uBA54\uC77C \uBC1C\uC1A1\uC744 \uD074\uB9AD\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/1.Login/1-1-3.png`)
                    },
                    {
                        order: 4,
                        procedure: React.createElement("span", null,
                            "\uAC00\uC785 \uC694\uCCAD\uD55C e-mail\uC744 \uD655\uC778 \uD6C4 \uBC1C\uC1A1\uB41C e-mail\uC5D0\uC11C \uC778\uC99D\uD558\uAE30 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     \uBA54\uC77C \uC778\uC99D\uC774 \uC644\uB8CC \uB418\uC5C8\uC73C\uBA74 ",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uB85C\uADF8\uC778\uD558\uAE30\uB97C \uD074\uB9AD\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/1.Login/1-1-4.png`)
                    }
                ]
            },
            {
                sid: 2,
                sname: "로그인",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uD68C\uC6D0\uAC00\uC785 \uC2DC \uC791\uC131\uD558\uC600\uB358 \uC544\uC774\uB514(e-mail)\uC640 \uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD558\uACE0. ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uB85C\uADF8\uC778 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/1.Login/1-2-1.png`)
                    }
                ]
            },
            {
                sid: 3,
                sname: "아이디 찾기",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC544\uC774\uB514 \uCC3E\uAE30\uB97C \uD074\uB9AD\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/1.Login/1-3-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            "\uD68C\uC6D0\uAC00\uC785 \uC2DC \uC791\uC131\uD558\uC600\uB358 \uC774\uB984\uACFC \uC5F0\uB77D\uCC98\uB97C \uC791\uC131\uD6C4 \uCC3E\uAE30\uB97C \uD074\uB9AD\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            "\u279C",
                            " ",
                            React.createElement("span", { style: { color: "red" } },
                                "\u2461",
                                " "),
                            "\uCC3E\uAE30\uB97C \uD074\uB9AD\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            "\u279C",
                            " \uAC00\uC785 \uC2DC \uC791\uC131\uD558\uC600\uB358 \uC544\uC774\uB514(e-mail)\uB97C \uD655\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/1.Login/1-3-2.png`)
                    }
                ]
            },
            {
                sid: 4,
                sname: "비밀번호 찾기",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uBE44\uBC00\uBC88\uD638 \uCC3E\uAE30\uB97C \uD074\uB9AD\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/1.Login/1-4-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            "\uC544\uC774\uB514, \uC774\uB984, \uC5F0\uB77D\uCC98\uB97C \uC791\uC131 \uD6C4 ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uCC3E\uAE30\uB97C \uD074\uB9AD\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/1.Login/1-4-2.png`)
                    },
                    {
                        order: 3,
                        procedure: React.createElement("span", null,
                            "\uAC00\uC785 \uC2DC \uC791\uC131\uD55C \uC544\uC774\uB514(e-mail)\uB85C \uC0C8 \uBE44\uBC00\uBC88\uD638\uAC00 \uC804\uC1A1 \uB418\uC5C8\uB2E4\uB294 \uBA54\uC2DC\uC9C0\uB97C \uD655\uC778 \uD6C4 ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uD655\uC778\uC744 \uD074\uB9AD\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     \uAC00\uC785 \uC2DC \uC791\uC131\uD55C \uC544\uC774\uB514(e-mail)\uB97C \uD655\uC778\uD558\uC5EC \uC0C8 \uBE44\uBC00\uBC88\uD638\uB97C \uD655\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/1.Login/1-4-3.png`)
                    }
                ]
            },
            {
                sid: 5,
                sname: "다국어 설정",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uD55C\uAD6D\uC5B4, English, \u4E2D\u6587 \uC120\uD0DD\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/1.Login/1-5-1.png`)
                    },
                ]
            }
        ]
    },
    //   222   //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        "id": 2,
        "mname": "Dashboard",
        "subMenu": [
            {
                sid: 1,
                sname: "Dashboard",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Portal 웹사이트 사용자가 전력설비 및 진단점검 관련 현황을 한눈에 파악할 수 있는 대시보드를 제공하며 등록설비 및 등록사업장 현황, e-Health Check (e-HC) 진행 현황, 점검/사고이력 현황, 서비스 요청 및 진행 현황정보를 커스터마이징 배치로 지원하는 서비스 입니다.",
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-1-0.png`)
                    }
                ]
            },
            {
                sid: 2,
                sname: "Dashboard - 운영 현황",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC0AC\uC6A9\uC790\uAC00 e-Health Portal\uC5D0 \uB4F1\uB85D\uD574\uC11C \uAD00\uB9AC\uD558\uACE0 \uC788\uB294 \uC804\uB825\uC124\uBE44 \uD604\uD669 \uBC0F \uC0AC\uC5C5\uC7A5\uC5D0 \uB300\uD55C \uC694\uC57D\uC815\uBCF4\uB97C \uD45C\uC2DC\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-1-1.png`)
                    }
                ]
            },
            {
                sid: 3,
                sname: "Dashboard - e-HC 진행률",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " e-Health Check \uC11C\uBE44\uC2A4 \uC9C4\uD589 \uD604\uD669\uC5D0 \uB300\uD55C \uC694\uC57D\uC815\uBCF4 \uD45C\uC2DC, e-Health Portal \uC6F9\uC0AC\uC774\uD2B8\uC5D0 \uB4F1\uB85D \uD6C4 \uC9C4\uB2E8\uC810\uAC80 \uBBF8\uC9C4\uD589 \uC804\uB825\uC124\uBE44\uC758 \uBE44\uC728\uC744 \uD45C\uC2DC\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-1-2.png`)
                    },
                ]
            },
            {
                sid: 4,
                sname: "Dashboard - e-HC Status",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " e-Health Portal\uC5D0 \uB4F1\uB85D \uD6C4 \uC9C4\uB2E8\uC810\uAC80\uC744 \uC9C4\uD589\uD55C \uC804\uB825\uC124\uBE44\uC758 3\uB2E8\uACC4\uBCC4 e-Health Check \uD3C9\uADE0 \uC810\uC218\uC640 \uC804\uB825\uC124\uBE44\uBCC4 \uC810\uC218 \uD604\uD669\uC744 \uD45C\uC2DC\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-1-3.png`)
                    },
                ]
            },
            {
                sid: 5,
                sname: "Dashboard - e-HC 평균 점수",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uC0AC\uC5C5\uC7A5 \uAE30\uC900 \uAE30\uAE30\uC758 \uD3C9\uADE0 \uC810\uC218\uB97C \uD45C\uC2DC\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-1-4.png`)
                    },
                ]
            },
            {
                sid: 6,
                sname: "Dashboard - 노후 교체 현황",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2464"),
                            " \uB178\uD6C4 \uAD50\uCCB4 \uC694\uCCAD \uC124\uBE44\uC5D0 \uB300\uD574 SPG\uBCC4\uB85C \uC694\uCCAD \uD604\uD669\uC744 \uD45C\uC2DC\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-1-5.png`)
                    },
                ]
            },
            {
                sid: 7,
                sname: "Dashboard - e-HC 점수 현황",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2465"),
                            " \uB2E8\uACC4\uBCC4\uB85C \uAE30\uAE30\uC758 \uC810\uC218 \uD604\uD669\uC744 \uD45C\uC2DC\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-1-6.png`)
                    },
                ]
            },
            {
                sid: 8,
                sname: "Dashboard - 점검 사고 이력",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2466"),
                            " e-Health Portal\uC5D0\uC11C \uAD00\uB9AC\uD558\uB294 \uC804\uB825\uC124\uBE44 \uAD00\uB828\uD558\uC5EC LS ELECTRIC\uC5D0\uC11C \uC9C4\uD589\uD55C \uACFC\uAC70 \uC810\uAC80\uC774\uB825 \uD604\uD669\uC744 \uD45C\uC2DC\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-1-7.png`)
                    },
                ]
            },
            {
                sid: 9,
                sname: "Dashboard - 진단 점검 서비스",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2467"),
                            " \uC9C4\uB2E8 \uC810\uAC80 \uC11C\uBE44\uC2A4\uC758 \uAD00\uB828\uB41C \uBC14\uB85C \uAC00\uAE30 \uC11C\uBE44\uC2A4\uB97C \uD45C\uC2DC\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-1-8.png`)
                    },
                ]
            },
            {
                sid: 10,
                sname: "Dashboard - 설정",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2468"),
                            " \uC120\uD0DD\uD55C \uC0AC\uC5C5\uC7A5\uC5D0 \uB300\uD574\uC11C \uD540\uC14B \uAE30\uB2A5\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC811\uC18D \uC2DC \uC6D0\uD558\uB294 \uACF3\uC758 \uC815\uBCF4\uB97C \uBA54\uC778\uC73C\uB85C \uC9C0\uC815 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-1-9.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2469"),
                            " \uCE74\uB4DC\uC704\uCE58\uD3B8\uC9D1 \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD558\uC5EC \uD3B8\uC9D1\uBAA8\uB4DC\uB85C \uB4E4\uC5B4\uAC08 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u246A"),
                            " \uCE74\uB4DC\uB97C \uC6D0\uD558\uB294 \uC704\uCE58\uC5D0 \uB4DC\uB798\uADF8\uD558\uC5EC \uC704\uCE58\uB97C \uAD50\uD658\uD558\uB294 \uD615\uC2DD\uC73C\uB85C \uBCC0\uACBD \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u246B"),
                            " \uC800\uC7A5\uBC84\uD2BC\uC744 \uB20C\uB7EC \uBCC0\uACBD\uB41C \uC0C1\uD0DC\uB97C \uC800\uC7A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red", fontSize: "15px" } }, "\uBAA8\uBC14\uC77C \uBBF8\uC9C0\uC6D0")),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-1-10.png`)
                    }
                ]
            },
            {
                sid: 11,
                sname: "헤더 - My Account",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            "\uC744 \uD074\uB9AD\uD558\uC5EC \uC0AC\uC6A9\uC790\uC758 \uAC1C\uC778\uC815\uBCF4\uB97C \uD655\uC778\uD558\uACE0 \uC218\uC815 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-2-1-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC0AC\uC6A9\uC790\uC758 \uD0C0\uC785, \uC0AC\uC6A9\uC790 \uAC1C\uC778\uC815\uBCF4 \uBC0F \uD68C\uC0AC, \uC0AC\uC5C5\uC7A5 \uC5C5\uC885 \uB4F1\uC758 \uC0AC\uC6A9\uC790 \uC815\uBCF4\uB97C \uD655\uC778\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     \uC544\uC774\uB514, \uC774\uB984, \uD68C\uC0AC\uB97C \uC81C\uC678\uD55C \uC815\uBCF4\uC758 \uBCC0\uACBD\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     \uD0C8\uD1F4\uD558\uAE30\uB85C \uD68C\uC6D0 \uD0C8\uD1F4\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-2-1-2.png`)
                    }
                ]
            },
            {
                sid: 12,
                sname: "헤더 - 로그아웃",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            "\uC744 \uD074\uB9AD\uD558\uC5EC \uB85C\uADF8\uC544\uC6C3\uC744 \uC774\uC6A9 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-2-2-1.png`)
                    },
                    {
                        order: 2,
                        procedure: "로그아웃을 진행하여 해당 PC 또는 브라우저에서 로그인 유지 상태를 해제합니다.",
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-2-2-2.png`)
                    }
                ]
            },
            {
                sid: 13,
                sname: "헤더 - 알림",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC0AC\uC774\uD2B8\uC5D0\uC11C \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uC804\uB2EC \uB41C \uC54C\uB9BC \uBA54\uC2DC\uC9C0\uB97C \uD655\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-3-1.png`)
                    },
                ]
            },
            {
                sid: 14,
                sname: "헤더 - 다국어 설정",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uD55C\uAD6D\uC5B4, \uC601\uC5B4, \uC911\uAD6D\uC5B4\uB85C \uB418\uC5B4\uC788\uC73C\uBA70 \uC120\uD0DD\uB41C \uC5B8\uC5B4\uB85C \uC0AC\uC774\uD2B8\uB97C \uC0AC\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4(",
                            React.createElement("span", { style: { color: "red" } }, "\uBAA8\uBC14\uC77C \uBBF8\uC9C0\uC6D0"),
                            ")."),
                        captureImg: require(`/static/img/img_help/2.Dashboard/2-4-1.png`)
                    },
                ]
            }
        ]
    },
    //   333   //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        "id": 3,
        "mname": "e-Health Check",
        "subMenu": [
            {
                sid: 1,
                sname: "e-Health Checker",
                snameContents: [
                    {
                        order: 1,
                        procedure: "전력설비가 안전하고 효율적으로 운영될 수 있도록 3단계로 구분된 체계적인  Health Check (진단점검) 서비스를 제공하여 전력 설비의 건강 상태를 체크하는 서비스 입니다.",
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-0.png`)
                    }
                ]
            },
            {
                sid: 2,
                sname: "e-Health Checker - 트리",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uAC01 \uC0AC\uC6A9\uC790\uAC00 \uC18D\uD55C \uD68C\uC0AC ~ \uC804\uAE30\uC2E4\uC758 \uAE30\uAE30 \uC0C1\uD0DC, \uC810\uAC80 \uACB0\uACFC\uB97C \uB098\uD0C0\uB0B4\uC5B4 \uC8FC\uB294 \uD398\uC774\uC9C0\uC785\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            "\uC744 \uD074\uB9AD\uD558\uC5EC \uD2B8\uB9AC\uB97C \uD655\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-1-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uD654\uBA74 \uC67C\uCABD \uAC80\uC0C9\uCC3D\uC5D0 \uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-1-2.png`)
                    },
                    {
                        order: 3,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            "\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uD30C\uB780\uC0C9\uC73C\uB85C \uD3EC\uCEE4\uC2F1 \uB418\uC5B4 \uB098\uD0C0\uB0A9\uB2C8\uB2E4"),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-1-3.png`)
                    }
                ]
            },
            {
                sid: 3,
                sname: "e-Health Checker - e-HC Status",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uD604\uC7AC \uC120\uD0DD\uB41C \uAE30\uAE30\uC758 \uAC1C\uC218, \uC810\uAC80\uC8FC\uAE30, \uAE30\uAE30\uC758 \uC0C1\uD0DC\uB97C \uBCF4\uC5EC\uC90D\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-2-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC124\uC815 \uBC84\uD2BC\uC744 \uB20C\uB7EC \uC810\uAC80\uC8FC\uAE30 \uBCC0\uACBD\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC810\uAC80\uC8FC\uAE30\uB294 30\uC77C, 90\uC77C 180\uC77C, 365\uC77C\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-2-2.png`)
                    }
                ]
            },
            {
                sid: 4,
                sname: "e-Health Checker - e-HC List",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uD604\uC7AC Basic/Premium/Advanced \uC0C1\uD0DC\uC5D0 \uC120\uD0DD\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC120\uD0DD\uD55C \uC0C1\uD0DC\uC5D0 \uB300\uD55C \uAE30\uAE30 \uBAA9\uB85D\uC744 \uD655\uC778\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-3-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC0C8 \uB4F1\uB85D, \uAE30 \uB4F1\uB85D \uAE30\uAE30 \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC0C8 \uB4F1\uB85D : \uC9C4\uB2E8\uC810\uAC80 \uC9C4\uD589 \uC774\uB825\uC774 \uC5C6\uB294 \uAE30\uAE30,",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uAE30 \uB4F1\uB85D : \uC9C4\uB2E8\uC810\uAC80 \uC9C4\uD589 \uC774\uB825\uC774 \uC788\uB294 \uAE30\uAE30",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uC870\uAC74 \uAC80\uC0C9\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC870\uAC74\uC740 Panel \uBA85, \uC2DC\uB9AC\uC5BC \uBC88\uD638, \uB2F4\uB2F9\uC790\uBCC4 \uAC80\uC0C9 \uC785\uB825\uD558\uC5EC \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-3-2.png`)
                    },
                ]
            },
            {
                sid: 5,
                sname: "e-Health Checker - 진단점검",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC810\uAC80 \uC9C4\uD589 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uC9C4\uB2E8\uC810\uAC80\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-4-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            "\uC810\uAC80 \uC9C4\uD589 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uC9C4\uB2E8\uC810\uAC80\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            "\u279C",
                            " ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uAC01 \uC810\uAC80 \uD56D\uBAA9\uC740 \uAE30\uAE30, \uC810\uAC80 \uC0C1\uD0DC \uB9C8\uB2E4 \uB2E4\uB985\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-4-2.png`)
                    },
                    {
                        order: 3,
                        procedure: React.createElement("span", null,
                            "\uC810\uAC80 \uC9C4\uD589 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC Premium \uC9C4\uB2E8\uC810\uAC80\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            "\u279C",
                            " ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uD504\uB9AC\uBBF8\uC5C4 \uC9C4\uB2E8 \uB2E8\uACC4\uB97C \uC870\uD68C\uD558\uC5EC \uBAA9\uB85D\uC744 \uC694\uCCAD \uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            "\u279C",
                            " ",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uC810\uC218\uAC00 \uB0AE\uC740 \uACBD\uC6B0 Premium \uC9C4\uB2E8\uC810\uAC80 \uC694\uCCAD\uC744 \uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-4-3.png`)
                    },
                    {
                        order: 4,
                        procedure: React.createElement("span", null,
                            "\uC7AC\uC9C4\uD589 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uC9C4\uB2E8\uC810\uAC80 \uC7AC\uC9C4\uD589\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2464"),
                            " \uB178\uB9D0 \uC9C4\uB2E8 \uB2E8\uACC4\uB97C \uC870\uD68C\uD558\uC5EC \uBAA9\uB85D\uC744 \uC694\uCCAD \uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2465"),
                            " \uC810\uC218\uAC00 \uB192\uC740 \uACBD\uC6B0 \uB178\uB9D0\uB85C \uC774\uB3D9 \uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2466"),
                            " \uC694\uCCAD \uC2DC \uD31D\uC5C5\uCC3D \uC54C\uB9BC\uC774 \uB739\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-4-4.png`)
                    }
                ]
            },
            /* {
                sid: 6,
                sname: "e-Health Checker - 진단점검(프리미엄 진단점검 요청)",
                snameContents: [
                    {
                        order: 1,
                        procedure: <span>점검 진행 버튼을 클릭하여 진단점검이 가능합니다.<br></br>          {"\u279C"} <span style={{ color: "red" }}>{"\u2462"}</span> 프리미엄 진단 단계를 조회하여 목록을 요청 합니다.<br></br>          {"\u279C"} <span style={{ color: "red" }}>{"\u2463"}</span> 점수가 낮은 경우 프리미엄 진단점검 요청을 합니다.</span>,
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-4-3.png`)
                    }
                ]
            },
            {
                sid: 7,
                sname: "e-Health Checker - 진단점검(재진행 요청)",
                snameContents: [
                    {
                        order: 1,
                        procedure: <span>점검 진행 버튼을 클릭하여 진단점검이 가능합니다.<br></br>          {"\u279C"}<span style={{ color: "red" }}>{"\u2464"}</span> 노말 진단 단계를 조회하여 목록을 요청 합니다.<br></br>          {"\u279C"}<span style={{ color: "red" }}>{"\u2465"}</span> 점수가 높은 경우 노말로 이동 합니다.<br></br>          {"\u279C"}<span style={{ color: "red" }}>{"\u2466"}</span> 요청 시 팝업창 알림이 뜹니다.</span>,
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-4-4.png`)
                    }
                ]
            }, */
            {
                sid: 6,
                sname: "e-Health Checker - VCB 진단점검(Basic)",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uD584\uBC84\uAC70 \uBA54\uB274\uC5D0\uC11C \u2018Dashboard\u2019 \uB97C \uD074\uB9AD\uD558\uC5EC e-HC Dashboard \uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uAE30\uAE30 \uD2B8\uB9AC\uC5D0\uC11C \u2018\uCCAD\uC8FC \u2192 2\uC0AC\uC5C5\uC7A5 \u2192 \uC804\uAE30\uC2E41 \u2192 VCB\u2019 \uB97C \uC120\uD0DD\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " e-HC List \uC5D0\uC11C \uC810\uAC80 \uD560 \uAE30\uAE30\uC758 \u2018\uC2DC\uC791\u2019 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uBA74, \uC6B0\uCE21\uC5D0 \uC9C4\uB2E8\uC810\uAC80 \uD654\uBA74\uC774 \uB098\uD0C0\uB0A9\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " VCB\uC5D0 \uB300\uD55C \uC9C4\uB2E8\uC810\uAC80\uC744 \uC9C4\uD589\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "\uC644\uB8CC \uC2DC \uC7AC\uC9C4\uD589, \uACF5\uC720, \uD504\uB9AC\uBBF8\uC5C4 \uC9C4\uB2E8\uC810\uAC80 \uC694\uCCAD\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4"),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-4-5.png`)
                    },
                    {
                        order: 2,
                        procedure: "진단점검(VCB 예시)",
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-4-6.png`)
                    },
                    {
                        order: 3,
                        procedure: "진단점검(VCB 예시)",
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-1-4-7.png`)
                    }
                ]
            },
            {
                sid: 7,
                sname: "기기등록 현황",
                snameContents: [
                    {
                        order: 1,
                        procedure: "사용자가 e-Health Portal 웹사이트에 등록해서 관리하고 있는 전력설비의 세부적인 정보와 함께 e-Health Check 진단점검 점수를 제공하고 필요시 노후화된 설비의 교체를 요청합니다.",
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-2-0.png`)
                    }
                ]
            },
            {
                sid: 8,
                sname: "기기등록 현황 - 목록",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC0AC\uC5C5\uC7A5\uC758 \uB4F1\uB85D \uB418\uC5B4 \uC788\uB294 \uAE30\uAE30 \uBAA9\uB85D\uC744 \uC694\uCCAD\uD558\uC5EC \uBCF4\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC870\uD68C\uB97C \uC774\uC6A9\uD558\uC5EC \uC18C\uC18D\uB41C \uD68C\uC0AC-\uC0AC\uC5C5\uC7A5\uB4E4\uC758 \uAE30\uAE30\uB97C \uD655\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC870\uAC74\uC740 \uC0C1\uC138 \uC0AC\uC5C5\uC7A5, \uC804\uAE30\uC2E4, \uAE30\uAE30 \uBA85\uC73C\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-2-1.png`)
                    },
                ]
            },
            {
                sid: 9,
                sname: "기기등록 현황 - 노후교체 요청",
                snameContents: [
                    {
                        order: 1,
                        procedure: "노후된 기기 요청 신청을 합니다.",
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-2-2.png`)
                    },
                ]
            },
            {
                sid: 10,
                sname: "기기등록 현황 - List Download(관리자)",
                snameContents: [
                    {
                        order: 1,
                        procedure: "관리자, 엔지니어만 활성화되며 선택된 회사-사업장의 기기 정보 목록을 다운로드 할 수 있습니다.\n     모바일은 미지원",
                        captureImg: require(`/static/img/img_help/3.e-Health Checker/3-2-3.png`)
                    },
                ]
            }
        ]
    },
    //   444   //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        "id": 4,
        "mname": "Report",
        "subMenu": [
            {
                sid: 1,
                sname: "진단점검 Report",
                snameContents: [
                    {
                        order: 1,
                        procedure: "포탈 사용자 편의성 향상을 위하여 e-Health Check 서비스에서 생성된 진단점검 보고서와 전력설비의 출하검사성적서를 사업장단위로 제공하는 서비스 입니다.",
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-1-0.png`)
                    }
                ]
            },
            {
                sid: 2,
                sname: "진단점검 Report - 조회",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC0C1\uC138 \uC0AC\uC5C5\uC7A5, \uC804\uAE30\uC2E4, \uC870\uD68C\uAE30\uAC04 \uC635\uC158\uBCC4\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-1-1-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            "Filter\uB294 \uAE30\uAE30\uC720\uD615(\uC804\uCCB4, \uBC30\uC804\uBC18, \uC720\uC785\uC2DDTR, ACB, GIS, MoldTR, VCB) 7\uAC00\uC9C0\uC640 \uC810\uAC80\uB2E8\uACC4(\uC804\uCCB4, Basic, Premium, Advanced) 4\uAC00\uC9C0\uB85C ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-1-1-2.png`)
                    },
                    {
                        order: 3,
                        procedure: React.createElement("span", null,
                            "\uAC80\uC0C9\uC740 \uBAA8\uB378 \uBA85, \uC2DC\uB9AC\uC5BC \uBC88\uD638\uB85C ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            "\uC744 \uD074\uB9AD\uD558\uC5EC \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-1-1-3.png`)
                    }
                ]
            },
            {
                sid: 3,
                sname: "진단점검 Report - 보기",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uBCF4\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uC6B0\uCE21\uC5D0 \uC9C4\uB2E8\uC810\uAC80 \uACB0\uACFC Report \uBCF4\uAE30\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     \uBAA8\uBC14\uC77C\uC740 ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uBCF4\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uD558\uB2E8\uC73C\uB85C \uB0B4\uB9AC\uBA74 \uBC14\uB85C \uBCF4\uAE30\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-1-2.png`)
                    }
                ]
            },
            {
                sid: 4,
                sname: "진단점검 Report - PDF 다운로드",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uB2E4\uC6B4\uB85C\uB4DC\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            "\u279C",
                            "\uBAA8\uBC14\uC77C\uC740 \uC0C1\uC138\uBCF4\uAE30\uC5D0\uC11C \uB2E4\uC6B4\uB85C\uB4DC\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uD074\uB9BD \uBAA8\uC591 \uC544\uC774\uCF58 \uD074\uB9AD \uC2DC PDF \uBC14\uB85C \uAC00\uAE30\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            "\u279C",
                            " \uBC14\uB85C\uAC00\uAE30 \uB0B4\uC5D0\uC11C \uB2E4\uC6B4\uB85C\uB4DC\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-1-3-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC120\uD0DD\uB41C Report\uC5D0 \uB300\uD574 \uC77C\uAD04\uB2E4\uC6B4\uB85C\uB4DC(\uC555\uCD95\uD30C\uC77C)\uC744 \uC81C\uACF5\uD569\uB2C8\uB2E4. (\uBAA8\uBC14\uC77C \uC81C\uC678)"),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-1-3-2.png`)
                    }
                ]
            },
            {
                sid: 5,
                sname: "진단점검 Report - 진단결과 공유",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uC9C4\uB2E8\uACB0\uACFC Report\uB97C ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC9C4\uB2E8\uACB0\uACFC \uACF5\uC720 \uBC0F \uACF5\uC720 \uBAA8\uC591 \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-1-4-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            "\uC9C4\uB2E8\uACB0\uACFC Report\uB97C \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC5D0\uAC8C ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC774\uBA54\uC77C\uB85C \uACF5\uC720 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-1-4-2.png`)
                    },
                ]
            },
            {
                sid: 6,
                sname: "Test Report",
                snameContents: [
                    {
                        order: 1,
                        procedure: "전력설비 출하검사성적서 View를 통하여 검사 항목별 내용을 파악하거나 PDF 파일로 다운로드 제공합니다.",
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-2-0.png`)
                    }
                ]
            },
            {
                sid: 7,
                sname: "Test Report - 조회",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " Filter\uB294 \uAE30\uAE30\uC720\uD615(\uC804\uCCB4, \uBC30\uC804\uBC18, \uC720\uC785\uC2DDTR, ACB, GIS, MoldTR, VCB)\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          \uAC80\uC0C9\uC740 \uBAA8\uB378 \uBA85, \uC2DC\uB9AC\uC5BC \uBC88\uD638\uB85C ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-2-1-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC2DC\uB9AC\uC5BC \uBC88\uD638\uB97C \uC9C1\uC811 \uC785\uB825\uD558\uC5EC \uAC80\uC0C9\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4. ",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uBAA8\uBC14\uC77C\uC740 QR\uCF54\uB4DC \uC2A4\uCE94\uACFC \uC2DC\uB9AC\uC5BC \uBC88\uD638 \uC9C1\uC5C5 \uC785\uB825\uD558\uC5EC \uAC80\uC0C9\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-2-1-2.png`)
                    },
                    {
                        order: 3,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2464"),
                            " \uC2DC\uB9AC\uC5BC \uBC88\uD638 \uBC84\uD2BC \uD074\uB9AD \uC2DC \uD31D\uC5C5 \uD654\uBA74. ",
                            React.createElement("span", { style: { color: "red" } }, "\u2465"),
                            " QR \uBC84\uD2BC \uD074\uB9AD \uC2DC \uD31D\uC5C5 \uD654\uBA74"),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-2-1-3.png`)
                    }
                ]
            },
            {
                sid: 8,
                sname: "Test Report - 성적서 다운로드",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC131\uC801\uC11C\uB97C \uB2E4\uC6B4\uB85C\uB4DC \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC120\uD0DD\uB41C \uC131\uC801\uC11C\uC5D0 \uB300\uD574 \uC77C\uAD04\uB2E4\uC6B4\uB85C\uB4DC (\uC555\uCD95\uD30C\uC77C)\uC744 \uC81C\uACF5\uD569\uB2C8\uB2E4. (\uBAA8\uBC14\uC77C \uC81C\uC678)"),
                        captureImg: require(`/static/img/img_help/4.Device registration status/4-2-2-1.png`)
                    }
                ]
            }
        ]
    },
    //   555   //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        "id": 5,
        "mname": "설비수명 Report",
        "subMenu": [
            {
                sid: 1,
                sname: "설비수명 인자 설정",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "e-Health Check \uC11C\uBE44\uC2A4\uC758 3\uB2E8\uACC4 \uC9C4\uB2E8\uC810\uAC80 \uACB0\uACFC\uB97C \uBC14\uD0D5\uC73C\uB85C LS ELCTRIC \uC804\uBB38\uAC00\uC758 \uC9C0\uC6D0\uC744 \uD1B5\uD558\uC5EC \uC124\uBE44\uC218\uBA85 \uC778\uC790\uB97C \uC124\uC815\uD558\uB294 \uAE30\uB2A5\uC744 \uC81C\uACF5(",
                            React.createElement("span", { style: { color: "red" } }, "\uBAA8\uBC14\uC77C\uC740 \uBBF8\uC9C0\uC6D0"),
                            ")."),
                        captureImg: require(`/static/img/img_help/5.Diagnostic Check Report/5-1-0.png`)
                    }
                ]
            },
            {
                sid: 2,
                sname: "설비수명 목록 및 조회",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC124\uBE44\uC218\uBA85 \uAE30\uAE30 \uBAA9\uB85D\uC744 \uC694\uCCAD \uD560 \uC218 \uC788\uACE0 \uD074\uB9AD \uC2DC \uC218\uBA85\uC778\uC790 \uC124\uC815\uC744 \uC9C4\uD589 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uAC80\uC0C9\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            "\u279C",
                            " \uAC80\uC0C9 \uC870\uAC74\uC740 \uAE30\uAE30 \uBA85, \uD328\uB110 \uBA85, \uC2DC\uB9AC\uC5BC \uBC88\uD638, \uBAA8\uB378 \uBA85\uC73C\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4. (",
                            React.createElement("span", { style: { color: "red" } }, "\uBAA8\uBC14\uC77C\uC740 \uBBF8\uC9C0\uC6D0"),
                            ")"),
                        captureImg: require(`/static/img/img_help/5.Diagnostic Check Report/5-1-1.png`)
                    }
                ]
            },
            {
                sid: 3,
                sname: "설비수명 인자 설정",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uC218\uBA85\uC778\uC790 \uC124\uC815\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uBAA9\uB85D \uC911 \uAE30\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uC124\uC815 \uD56D\uBAA9\uC73C\uB85C \uB4E4\uC5B4 \uAC08 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC124\uC815 \uD56D\uBAA9\uC5D0\uC11C \uC0AC\uC6A9\uC790\uAC00 \uD56D\uBAA9 \uBC0F \uC0AC\uC6A9\uC790 \uC785\uB825 \uAC12\uC744 \uC815\uD558\uC5EC \uCD94\uAC00\uD558\uC5EC",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            ",",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC800\uC7A5 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4(",
                            React.createElement("span", { style: { color: "red" } }, "\uBAA8\uBC14\uC77C\uC740 \uBBF8\uC9C0\uC6D0"),
                            ")."),
                        captureImg: require(`/static/img/img_help/5.Diagnostic Check Report/5-1-2-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            "\uC218\uBA85\uC778\uC790 \uC124\uC815\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uBAA9\uB85D \uC911 \uAE30\uAE30\uB97C \uD074\uB9AD\uD558\uC5EC \uC124\uC815 \uD56D\uBAA9\uC73C\uB85C \uB4E4\uC5B4 \uAC08 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC124\uC815 \uD56D\uBAA9\uC5D0\uC11C \uC2A4\uD06C\uB864\uC744 \uB0B4\uB9AC\uBA74 User Defined \uACF3\uC5D0 \uC0AC\uC6A9\uC790\uAC00 \uD56D\uBAA9\uC744 \uC0C8\uB86D\uAC8C \uCD94\uAC00 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4(",
                            React.createElement("span", { style: { color: "red" } }, "\uBAA8\uBC14\uC77C\uC740 \uBBF8\uC9C0\uC6D0"),
                            ")."),
                        captureImg: require(`/static/img/img_help/5.Diagnostic Check Report/5-1-2-2.png`)
                    }
                ]
            },
            {
                sid: 4,
                sname: "설비수명 Report",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "LS ELCTRIC\uC758 ALO \uD50C\uB7AB\uD3FC\uACFC \uC5F0\uACC4\uD558\uC5EC \uC804\uB825\uC124\uBE44 \uC218\uBA85\uACFC \uAD00\uB828\uB41C Lifecycle \uBCF4\uACE0\uC11C\uB97C \uC81C\uACF5.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " 23\uB144 \uC815\uC2DD \uC624\uD508 \uBC0F \uBE44\uC6A9 \uACF5\uC9C0 \uC608\uC815"),
                        captureImg: require(`/static/img/img_help/5.Diagnostic Check Report/5-2-0.png`)
                    }
                ]
            }
        ]
    },
    //   666   //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        "id": 6,
        "mname": "운영관리",
        "subMenu": [
            {
                sid: 1,
                sname: "사업장 전기실 관리",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Portal 웹사이트에 등록 및 관리를 희망하는 설비 등록을 위하여 전력설비가 운영되고 있는 회사, 사업장 정보를 등록하여 관리하는 기능 제공합니다.",
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-1-0.png`)
                    }
                ]
            },
            {
                sid: 2,
                sname: "사업장 전기실 관리 - 회사 검색(ADMIN)",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uAD00\uB9AC\uC790\uB294 \uD68C\uC0AC \uAC80\uC0C9\uC744 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-1-1.png`)
                    },
                ]
            },
            {
                sid: 3,
                sname: "사업장 전기실 관리 - 사업장 추가",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uC0AC\uC6A9\uC790\uB294 \uC0AC\uC5C5\uC7A5\uC744 \uCD94\uAC00\uC694\uCCAD \uB450 \uAC00\uC9C0 \uBC29\uBC95\uC73C\uB85C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC0AC\uC5C5\uC7A5 \uAC80\uC0C9 \uCD94\uAC00, \uC0AC\uC5C5\uC7A5 \uC2E0\uADDC\uB4F1\uB85D \uCD94\uAC00\uAC00 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-1-1.png`)
                    }
                ]
            },
            {
                sid: 4,
                sname: "사업장 전기실 관리 - 사업장 검색 추가",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uD074\uB9AD \uC2DC \uC0AC\uC5C5\uC7A5 ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uAC80\uC0C9 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uBC84\uD2BC\uC744 \uB20C\uB7EC \uBC14\uB85C \uCD94\uAC00 \uC694\uCCAD \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-1-2.png`)
                    },
                    {
                        order: 2,
                        procedure: "사업장 추가 시 사업장 요청으로 왼쪽 트리 창에 추가가 됩니다.",
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-1-3.png`)
                    }
                ]
            },
            {
                sid: 5,
                sname: "사업장 전기실 관리 - 사업장 신규등록 추가",
                snameContents: [
                    {
                        order: 1,
                        procedure: "사업장 신규 등록 시 회사명을 검색하여 간단하게 등록 할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-1-4.png`)
                    },
                    {
                        order: 2,
                        procedure: "사용자가 사업장 이미지, 사업장 명, 사업장 주소, 메모 정보 입력을 하여 추가 요청 및 저장을 할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-1-5.png`)
                    }
                ]
            },
            {
                sid: 6,
                sname: "사업장 전기실 관리 - 상세 사업장 신규 추가",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uD584\uBC84\uAC70 \uBA54\uB274\uC5D0\uC11C \u2018\uC6B4\uC601\uAD00\uB9AC ",
                            "\u279C",
                            " \uAE30\uAE30 \uB4F1\uB85D \uAD00\uB9AC\u2019 \uB97C \uD074\uB9AD\uD558\uC5EC, \uC0AC\uC5C5\uC7A5 \uC804\uAE30\uC2E4 \uAD00\uB9AC\uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC88C\uCE21 \uD2B8\uB9AC\uC5D0\uC11C LS ELECTRIC \uCCAD\uC8FC \uB97C \uC120\uD0DD \uD6C4 \u2018\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uCD94\uAC00\u2019\uB97C \uD074\uB9AD\uD558\uC5EC \uD654\uBA74 \uC774\uB3D9\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC0C1\uC138\uC0AC\uC5C5\uC7A5\uBA85, \uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C \uBC0F \uBA54\uBAA8\uB97C \uC785\uB825 \uD6C4 \u2018\uC800\uC7A5\u2019 \uC744 \uD074\uB9AD\uD558\uBA74 \uC0C1\uC138\uC0AC\uC5C5\uC7A5\uC774 \uCD94\uAC00\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-2-1.png`)
                    }
                ]
            },
            {
                sid: 7,
                sname: "사업장 전기실 관리 - 상세 사업장 수정",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC6B0\uCE21 \uC218\uC815 \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD558\uC5EC \uC0C1\uC138 \uC0AC\uC5C5\uC7A5\uC744 \uC218\uC815 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-1-2-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC0C1\uC138 \uC0AC\uC5C5\uC7A5 \uBA85, \uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C \uBC0F \uBA54\uBAA8\uB97C \uC785\uB825 \uD6C4 \u2018\uC800\uC7A5\u2019 \uC744 \uD074\uB9AD\uD558\uBA74 \uC0C1\uC138\uC0AC\uC5C5\uC7A5\uC774 \uC218\uC815\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-1-2-2.png`)
                    }
                ]
            },
            {
                sid: 8,
                sname: "사업장 전기실 관리 - 상세 사업장 수정",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uD2B8\uB9AC \uD65C\uC131\uD654 \uBC84\uD2BC\uC744 \uC774\uC6A9\uD558\uC5EC \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uBCF4\uC5EC\uC904 \uC9C0 \uC120\uD0DD \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uC6B0\uCE21 \uC218\uC815 \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD558\uC5EC \uC0C1\uC138 \uC0AC\uC5C5\uC7A5\uC744 \uC218\uC815 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-2-2.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2464"),
                            " \uC0C1\uC138 \uC0AC\uC5C5\uC7A5 \uBA85, \uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C \uBC0F \uBA54\uBAA8\uB97C \uC785\uB825 \uD6C4 \u2018\uC800\uC7A5\u2019 \uC744 \uD074\uB9AD\uD558\uBA74 \uC0C1\uC138\uC0AC\uC5C5\uC7A5\uC774 \uC218\uC815\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-2-3.png`)
                    }
                ]
            },
            {
                sid: 9,
                sname: "사업장 전기실 관리 - 상세 사업장 삭제",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2465"),
                            " \uC6B0\uCE21 \uC0AD\uC81C \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD558\uC5EC \uC0AD\uC81C\uB97C \uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("span", { style: { color: "red" } }, "\u2466"),
                            " \uD31D\uC5C5\uCC3D\uC774 \uB72C \uB4A4 \u2018\uD655\uC778\u2019 \uC744 \uD074\uB9AD\uD558\uBA74 \uC0C1\uC138\uC0AC\uC5C5\uC7A5\uC774 \uC0AD\uC81C\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-2-4.png`)
                    }
                ]
            },
            {
                sid: 10,
                sname: "사업장 전기실 관리 - 상세 사업장 삭제",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC6B0\uCE21 \uC0AD\uC81C \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD558\uC5EC \uC0AD\uC81C\uB97C \uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uD31D\uC5C5\uCC3D\uC774 \uB72C \uB4A4 \u2018\uD655\uC778\u2019 \uC744 \uD074\uB9AD\uD558\uBA74 \uC0C1\uC138\uC0AC\uC5C5\uC7A5\uC774 \uC0AD\uC81C\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-1-2-3.png`)
                    }
                ]
            },
            {
                sid: 11,
                sname: "사업장 전기실 관리 - 전기실 신규 추가",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uD584\uBC84\uAC70 \uBA54\uB274\uC5D0\uC11C \u2018\uC6B4\uC601\uAD00\uB9AC ",
                            "\u279C",
                            " \uAE30\uAE30 \uB4F1\uB85D \uAD00\uB9AC\u2019 \uB97C \uD074\uB9AD\uD558\uC5EC \uC0AC\uC5C5\uC7A5 \uC804\uAE30\uC2E4 \uAD00\uB9AC\uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC88C\uCE21 \uD2B8\uB9AC\uC5D0\uC11C LS ELECTRIC \uCCAD\uC8FC ",
                            "\u279C",
                            " 2\uC0AC\uC5C5\uC7A5 \uC744 \uC120\uD0DD \uD6C4 \u2018\uC2E0\uADDC \uC804\uAE30\uC2E4 \uCD94\uAC00\u2019\uB97C \uD074\uB9AD\uD558\uC5EC \uD654\uBA74 \uC774\uB3D9\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-1-3-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC804\uAE30\uC2E4\uBA85, \uC804\uAE30\uC2E4 \uB3C4\uBA74 \uCCA8\uBD80\uD30C\uC77C \uBC0F \uBA54\uBAA8\uB97C \uC785\uB825 \uD6C4 \u2018\uC800\uC7A5\u2019\uC744 \uD074\uB9AD\uD558\uBA74 \uC804\uAE30\uC2E4\uC774 \uCD94\uAC00\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-1-3-2.png`)
                    }
                ]
            },
            {
                sid: 12,
                sname: "사업장 전기실 관리 - 전기실 수정",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC6B0\uCE21 \uC218\uC815 \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD558\uC5EC \uC804\uAE30\uC2E4\uC744 \uC218\uC815 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-1-3-3.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uD2B8\uB9AC \uD65C\uC131\uD654 \uBC84\uD2BC, \uC804\uAE30\uC2E4\uBA85, \uC804\uAE30\uC2E4 \uB3C4\uBA74 \uCCA8\uBD80\uD30C\uC77C \uBC0F \uBA54\uBAA8\uB97C \uC785\uB825 \uD6C4 \u2018\uC218\uC815\u2019\uC744 \uD074\uB9AD\uD558\uBA74 \uC804\uAE30\uC2E4\uC774 \uC218\uC815\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-1-3-4.png`)
                    }
                ]
            },
            {
                sid: 13,
                sname: "사업장 전기실 관리 - 전기실 수정",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uD2B8\uB9AC \uD65C\uC131\uD654 \uBC84\uD2BC\uC744 \uC774\uC6A9\uD558\uC5EC \uB2E4\uB978 \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uBCF4\uC5EC\uC904 \uC9C0 \uC120\uD0DD \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uC6B0\uCE21 \uC218\uC815 \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD558\uC5EC \uC804\uAE30\uC2E4\uC744 \uC218\uC815 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-3-3.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2464"),
                            " \uD2B8\uB9AC \uD65C\uC131\uD654 \uBC84\uD2BC, \uC804\uAE30\uC2E4\uBA85, \uC804\uAE30\uC2E4 \uB3C4\uBA74 \uCCA8\uBD80\uD30C\uC77C \uBC0F \uBA54\uBAA8\uB97C \uC785\uB825 \uD6C4 \u2018\uC218\uC815\u2019\uC744 \uD074\uB9AD\uD558\uBA74 \uC804\uAE30\uC2E4\uC774 \uC218\uC815\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-3-4.png`)
                    }
                ]
            },
            {
                sid: 14,
                sname: "사업장 전기실 관리 - 전기실 삭제",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2464"),
                            " \uC6B0\uCE21 \uC0AD\uC81C \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD558\uC5EC \uC0AD\uC81C\uB97C \uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2465"),
                            " \uD31D\uC5C5 \uCC3D\uC774 \uB72C \uB4A4 \u2018\uD655\uC778\u2019 \uC744 \uD074\uB9AD\uD558\uBA74 \uC0C1\uC138\uC0AC\uC5C5\uC7A5\uC774 \uC0AD\uC81C\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-1-3-5.png`)
                    }
                ]
            },
            {
                sid: 15,
                sname: "사업장 전기실 관리 - 전기실 삭제",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2465"),
                            " \uC6B0\uCE21 \uC0AD\uC81C \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD558\uC5EC \uC0AD\uC81C\uB97C \uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2466"),
                            " \uD31D\uC5C5 \uCC3D\uC774 \uB72C \uB4A4 \u2018\uD655\uC778\u2019 \uC744 \uD074\uB9AD\uD558\uBA74 \uC0C1\uC138\uC0AC\uC5C5\uC7A5\uC774 \uC0AD\uC81C\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/u_6-1-3-5.png`)
                    }
                ]
            },
            {
                sid: 16,
                sname: "기기등록 관리",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Portal 웹사이트에 등록 및 관리를 희망하는 전력설비를 신규로 등록하여 관리할 수 있으며 향상된 사용자 등록 편의성을 제공합니다.",
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-2-0.png`)
                    }
                ]
            },
            {
                sid: 17,
                sname: "기기등록 관리 - 기기 개별등록",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uD584\uBC84\uAC70 \uBA54\uB274\uC5D0\uC11C \u2018\uC6B4\uC601\uAD00\uB9AC ",
                            "\u279C",
                            " \uAE30\uAE30 \uB4F1\uB85D \uAD00\uB9AC\u2019 \uB97C \uD074\uB9AD\uD558\uC5EC \uAE30\uAE30 \uB4F1\uB85D \uAD00\uB9AC\uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC88C\uCE21 \uD2B8\uB9AC\uC5D0\uC11C LS ELECTRIC \uCCAD\uC8FC ",
                            "\u279C",
                            " 2\uC0AC\uC5C5\uC7A5 ",
                            "\u279C",
                            " \uC804\uAE30\uC2E41 \uC744 \uC120\uD0DD \uD6C4 \uAE30\uAE30 \uB4F1\uB85D\uC744 \uD074\uB9AD\uD558\uC5EC \uD654\uBA74 \uC774\uB3D9\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uAC1C\uBCC4\uB4F1\uB85D\uC744 \uD074\uB9AD\uD558\uC5EC \uAC1C\uBCC4\uB4F1\uB85D \uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uAE30\uAE30\uBA85, Panel\uBA85, \uBAA8\uB378\uBA85, \uC2DC\uB9AC\uC5BC\uBC88\uD638, \uC804\uC555/\uC804\uB958 \uC815\uBCF4, \uC81C\uC870\uC0AC \uB4F1\uC744 \uC785\uB825\uD558\uACE0 \uC800\uC7A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-2-1.png`)
                    }
                ]
            },
            {
                sid: 18,
                sname: "기기등록 관리 - 기기 일괄등록",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \u2018\uC77C\uAD04\uB4F1\uB85D\u2019 \uC744 \uD074\uB9AD\uD558\uC5EC \uC77C\uAD04\uB4F1\uB85D \uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \u2018Excel \uC591\uC2DD \uB2E4\uC6B4\uB85C\uB4DC\u2019 \uB9C1\uD06C\uB85C \uC591\uC2DD\uC744 \uB2E4\uC6B4\uB85C\uB4DC\uD558\uC5EC \uC77C\uAD04\uB4F1\uB85D \uD560 \uAE30\uAE30 \uC815\uBCF4\uB97C \uC591\uC2DD\uC5D0 \uB9DE\uAC8C \uC785\uB825\uD558\uACE0 \uC800\uC7A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \u2018\uCCA8\uBD80\uD30C\uC77C \uC120\uD0DD\u2019 \uC744 \uD074\uB9AD\uD558\uC5EC \uAE30\uAE30\uC815\uBCF4\uB97C \uC785\uB825\uD55C \uC5D1\uC140\uD30C\uC77C\uC744 \uC120\uD0DD\uD558\uACE0 \uC544\uB798\uC758 \u2018Upload\u2019 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uC77C\uAD04\uB4F1\uB85D\uC744 \uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uC77C\uAD04 \uB4F1\uB85D\uD55C \uACB0\uACFC\uB97C \uD655\uC778\uD569\uB2C8\uB2E4(",
                            React.createElement("span", { style: { color: "red" } }, "\uBAA8\uBC14\uC77C \uBBF8\uC9C0\uC6D0"),
                            ")."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-2-2-1.png`)
                    }
                ]
            },
            {
                sid: 19,
                sname: "(기기 일괄등록)엑셀 양식 설명",
                snameContents: [
                    {
                        order: 1,
                        procedure: "엑셀 양식 설명",
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-2-2-2.png`)
                    }
                ]
            },
            {
                sid: 20,
                sname: "기기등록 관리 - 기기 정보 목록",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uD584\uBC84\uAC70 \uBA54\uB274\uC5D0\uC11C \u2018\uC6B4\uC601\uAD00\uB9AC ",
                            "\u279C",
                            " \uAE30\uAE30 \uB4F1\uB85D \uAD00\uB9AC\u2019 \uB97C \uD074\uB9AD\uD558\uC5EC \uAE30\uAE30 \uB4F1\uB85D \uAD00\uB9AC\uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC88C\uCE21 \uD2B8\uB9AC\uC5D0\uC11C LS ELECTRIC \uCCAD\uC8FC ",
                            "\u279C",
                            " 2\uC0AC\uC5C5\uC7A5 ",
                            "\u279C",
                            " \uC804\uAE30\uC2E41 \uC744 \uC120\uD0DD\uD558\uC5EC \uD654\uBA74 \uC774\uB3D9\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC804\uAE30\uC2E41\uC5D0 \uB4F1\uB85D\uB41C \uAE30\uAE30\uC815\uBCF4 \uBAA9\uB85D\uC744 \uD655\uC778\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     \uAE30\uAE30 \uBAA9\uB85D\uC758 \uC0AD\uC81C\uB97C \uC81C\uC678\uD55C \uD544\uB4DC\uB97C \uD074\uB9AD\uD558\uBA74, \uD574\uB2F9 \uAE30\uAE30\uC758 \uC0C1\uC138\uC815\uBCF4\uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-2-3.png`)
                    }
                ]
            },
            {
                sid: 21,
                sname: "기기등록 관리 - 기기 조회",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uBAA8\uB378 \uBA85, \uC2DC\uB9AC\uC5BC \uBC88\uD638\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-2-4.png`)
                    }
                ]
            },
            {
                sid: 22,
                sname: "기기등록 관리 - 기기 상세 정보",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uAE30\uAE30 \uC815\uBCF4 \uBAA9\uB85D \uC870\uD68C\uC5D0\uC11C \uC0C1\uC138\uC815\uBCF4\uB97C \uC870\uD68C\uD560 \uAE30\uAE30\uB97C \uD074\uB9AD\uD558\uBA74, \uD574\uB2F9 \uAE30\uAE30\uC758 \uC0C1\uC138\uC815\uBCF4\uB97C \uC870\uD68C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC81C\uC870\uC0AC, \uCCA8\uBD80\uD30C\uC77C, \uBA54\uBAA8 \uB0B4\uC6A9\uC744 \uCD94\uAC00\uB85C \uD655\uC778\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uAE30\uAE30 \uC815\uBCF4\uC5D0 \uB300\uD55C \uC218\uC815 \uBC0F \uC0AD\uC81C\uB97C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-2-5.png`)
                    }
                ]
            },
            {
                sid: 23,
                sname: "기기등록 관리 - 기기 정보 수정",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uAE30\uAE30 \uC815\uBCF4 \uC0C1\uC138\uC815\uBCF4 \uD654\uBA74\uC5D0\uC11C \u2018\uC218\uC815 \uC544\uC774\uCF58\u2019 \uC744 \uD074\uB9AD\uD558\uBA74, \uAE30\uAE30\uC815\uBCF4 \uC218\uC815\uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC815\uBCF4\uB97C \uC218\uC815\uD558\uACE0 \u2018\uC800\uC7A5\u2019 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uBA74 \uAE30\uAE30 \uC815\uBCF4\uAC00 \uC218\uC815\uB429\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     (\uC608\uC2DC) \uCCA8\uBD80\uD30C\uC77C \uCD94\uAC00, \uBA54\uBAA8 \uC218\uC815"),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-2-6.png`)
                    }
                ]
            },
            {
                sid: 24,
                sname: "기기등록 관리 - 기기 삭제(일괄 선택 삭제)",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uAE30\uAE30 \uC815\uBCF4 \uBAA9\uB85D \uC870\uD68C\uC5D0\uC11C \uC0AD\uC81C\uD560 \uAE30\uAE30\uB97C \uC120\uD0DD\uD558\uC5EC \uAE30\uAE30\uB97C \uC77C\uAD04 \uC0AD\uC81C\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC0AD\uC81C\uD560 \uAE30\uAE30\uB97C \uCCB4\uD06C\uBC15\uC2A4\uB97C \uD074\uB9AD\uD558\uC5EC \uC120\uD0DD\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC0C1\uB2E8\uC758 \u2018\uC0AD\uC81C \uC544\uC774\uCF58\u2019 \uC744 \uD074\uB9AD\uD558\uBA74 \uC120\uD0DD\uB41C \uAE30\uAE30\uB97C \uC77C\uAD04 \uC0AD\uC81C\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uAE30\uAE30 \uC815\uBCF4 \uBAA9\uB85D\uC758 \u2018\uC0AD\uC81C \uC544\uC774\uCF58\u2019 \uC744 \uD074\uB9AD\uD558\uBA74 \uD574\uB2F9 \uAE30\uAE30\uAC00 \uC0AD\uC81C\uB429\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "* \uBAA8\uBC14\uC77C \uD654\uBA74\uC5D0\uC11C\uB294 \uC77C\uAD04\uC0AD\uC81C\uB97C \uC81C\uACF5\uD558\uC9C0 \uC54A\uC74C")),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-2-7.png`)
                    }
                ]
            },
            {
                sid: 25,
                sname: "기기등록 관리 - 다운로드",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uB2E4\uC6B4\uB85C\uB4DC \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uD574\uB2F9 \uC804\uAE30\uC2E4\uC758 \uAE30\uAE30 \uBAA9\uB85D \uD655\uC778\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/6.Operations Management/6-2-8.png`)
                    }
                ]
            }
        ]
    },
    //   777   //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        "id": 7,
        "mname": "Management",
        "subMenu": [
            {
                sid: 1,
                sname: "승인 관리",
                snameContents: [
                    {
                        order: 1,
                        procedure: "신규 가입자 승인, 사업장 승인, 진단점검/노후교체 요청 관리가 가능합니다.",
                        captureImg: require(`/static/img/img_help/7.Management/7-1-0.png`)
                    }
                ]
            },
            {
                sid: 2,
                sname: "승인 관리 - 신규 가입자",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uAD00\uB9AC\uC790\uAC00 \uC2E0\uADDC \uAC00\uC785\uC790\uC758 \uBAA9\uB85D\uC744 \uD655\uC778\uD558\uACE0 \uC2B9\uC778\uC694\uCCAD\uC744 \uD655\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-1-1-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC2E0\uADDC \uAC00\uC785\uC790\uC758 \uC815\uBCF4\uB97C \uD655\uC778\uD558\uACE0 \uC2B9\uC778 \uC5EC\uBD80(\uC2B9\uC778, \uBC18\uB824), \uC0AC\uC6A9\uC790 \uD0C0\uC785(Admin, Engineer, User)\uC744 \uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            "\uC0AC\uC6A9\uC790 \uD0C0\uC785 \uC9C0\uC815 \uC2DC Admin, Engineer\uB294 \uCD94\uAC00\uAC00 \uC548 \uB429\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            "\uC0AC\uC6A9\uC790 \uD0C0\uC785 \uC9C0\uC815 \uC2DC User\uB294 \uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D\uC774 \uCD94\uAC00 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-1-1-2.png`)
                    },
                    {
                        order: 3,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC0AC\uC6A9\uC790 \uD0C0\uC785 \uC9C0\uC815 \uC2DC User\uB294 \uD68C\uC0AC_\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D\uC774 \uCD94\uAC00 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "\u279C",
                            "\uC0AC\uC6A9\uC790 \uD0C0\uC785 \uC9C0\uC815 \uC2DC Admin, Engineer\uB294 \uCD94\uAC00\uAC00 \uC548 \uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-1-1-3.png`)
                    },
                    {
                        order: 4,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uD68C\uC0AC-\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uC2DC \uD68C\uC0AC\uC640 \uC0AC\uC5C5\uC7A5\uC744 \uCD94\uAC00\uD558\uC5EC \uB4F1\uB85D\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-1-1-4.png`)
                    }
                ]
            },
            {
                sid: 3,
                sname: "승인 관리 - 사업장 승인 요청",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uAD00\uB9AC\uC790\uAC00 \uC0AC\uC5C5\uC7A5 \uC2B9\uC778 \uC694\uCCAD \uBAA9\uB85D\uC744 \uD655\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-1-2-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            "\uC0AC\uC6A9\uC790\uAC00 \uC694\uCCAD\uD55C \uC0AC\uC5C5\uC7A5\uC758 \uC815\uBCF4\uB97C \uD655\uC778\uD558\uACE0 \uC2B9\uC778 \uC5EC\uBD80(\uC2B9\uC778, \uBC18\uB824)\uC744 \uD655\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-1-2-2.png`)
                    },
                    {
                        order: 3,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC218\uC815 \uC544\uC774\uCF58\uC744 \uD074\uB9AD\uD558\uC5EC \uC0AC\uC6A9\uC790\uAC00 \uC694\uCCAD\uD55C \uC0AC\uC5C5\uC7A5\uC758 \uC815\uBCF4\uB97C \uC218\uC815 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-1-2-3.png`)
                    },
                    {
                        order: 4,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uC0AC\uC5C5\uC7A5 \uBA85, \uBA54\uBAA8\uB97C \uC218\uC815\uD558\uC5EC \uC800\uC7A5\uC744 \uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-1-2-4.png`)
                    }
                ]
            },
            {
                sid: 4,
                sname: "승인 관리 - 진단점검/노후교체 승인 요청",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC9C4\uB2E8\uC810\uAC80/\uB178\uD6C4\uAD50\uCCB4 \uC2B9\uC778 \uC694\uCCAD \uBAA9\uB85D\uC744 \uC694\uCCAD\uD558\uC5EC \uD655\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            "BASIC\uC5D0\uC11C \uC9C4\uB2E8\uC810\uAC80 \uC644\uB8CC \uD6C4 PREMIUM \uC9C4\uB2E8 \uC694\uCCAD\uB41C \uC0C1\uD0DC\uC758 \uAE30\uAE30,",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            "\uAD50\uCCB4 \uC694\uCCAD\uB41C \uAE30\uAE30,",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            "\uC5D4\uC9C0\uB2C8\uC5B4 \uBC30\uC815\uC774 \uC644\uB8CC \uB41C \uC811\uC218 \uC644\uB8CC \uC0C1\uD0DC\uC758 \uAE30\uAE30 \uBAA9\uB85D\uC744 \uD655\uC778\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC2B9\uC778 \uC694\uCCAD\uC5D0\uC11C \uAD50\uCCB4\uC694\uCCAD\uC744 \uD074\uB9AD\uD558\uC5EC \uC5D4\uC9C0\uB2C8\uC5B4 \uBC30\uC815\uC744 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-1-3-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            "\uAD50\uCCB4 \uC694\uCCAD \uC2B9\uC778 \uC694\uCCAD \uC2DC ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC0C1\uC138\uC815\uBCF4 \uBC0F \uC5D4\uC9C0\uB2C8\uC5B4 \uC120\uD0DD \uBC0F \uD655\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC5D4\uC9C0\uB2C8\uC5B4\uB97C \uAC80\uC0C9\uD558\uC5EC \uBC30\uC815\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-1-3-2.png`)
                    }
                ]
            },
            {
                sid: 5,
                sname: "사용자 관리",
                snameContents: [
                    {
                        order: 1,
                        procedure: "사업장별 사용자 목록, 사용자 타입, 사용자별 활성화/비활성화 관리를 할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/7.Management/7-2-0.png`)
                    }
                ]
            },
            {
                sid: 6,
                sname: "사용자 관리 - 목록",
                snameContents: [
                    {
                        order: 1,
                        procedure: "사용자 소속 기준으로 사용자 목록을 조회 할 수 있습니다.\n     사업장, 사용자 타입으로 필요한 정보만 불러올 수 있습니다.",
                        captureImg: require(`/static/img/img_help/7.Management/7-2-1.png`)
                    }
                ]
            },
            {
                sid: 7,
                sname: "사용자 관리 - 정보수정",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "\uC0AC\uC6A9\uC790 \uBAA9\uB85D\uC5D0\uC11C \uC0AC\uC6A9\uC790\uB97C \uD074\uB9AD\uD558\uBA74",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC0AC\uC6A9\uC790 \uC0C1\uC138\uC815\uBCF4 \uBC0F \uC0AC\uC6A9\uC790 \uD0C0\uC785 \uBCC0\uACBD, \uD68C\uC0AC-\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D \uCD94\uAC00, \uC0AC\uC6A9\uC790 \uD65C\uC131\uD654 \uBC84\uD2BC\uC744 \uBCC0\uACBD \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-2-2.png`)
                    }
                ]
            },
            {
                sid: 8,
                sname: "사업장 관리",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Portal 웹사이트의 회사-사업장 추가, 사업장별 데이터, 사업장 현황을 관리 할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/7.Management/7-3-0.png`)
                    }
                ]
            },
            {
                sid: 9,
                sname: "사업장 관리 - 회사 추가",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uD68C\uC0AC \uCD94\uAC00\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-3-1.png`)
                    }
                ]
            },
            {
                sid: 10,
                sname: "사업장 관리 - 회사 수정/삭제",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uD68C\uC0AC \uC0C1\uC138\uC815\uBCF4 \uD655\uC778\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uD68C\uC0AC \uC218\uC815, \uC0AD\uC81C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            "\uD31D\uC5C5 \uCC3D\uC774 \uB72C \uB4A4 ",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            "\u2018\uD655\uC778\u2019 \uC744 \uD074\uB9AD\uD558\uBA74 \uD68C\uC0AC\uAC00 \uC0AD\uC81C\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-3-2.png`)
                    }
                ]
            },
            {
                sid: 11,
                sname: "사업장 관리 - 사업장 추가",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uC0AC\uC5C5\uC7A5 \uCD94\uAC00\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-3-3.png`)
                    }
                ]
            },
            {
                sid: 12,
                sname: "사업장 관리 - 사업장 수정/삭제",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2464"),
                            " \uC0AC\uC5C5\uC7A5 \uC0C1\uC138\uC815\uBCF4 \uD655\uC778\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2465"),
                            " \uC0AC\uC5C5\uC7A5 \uC218\uC815, \uC0AD\uC81C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " ",
                            React.createElement("span", { style: { color: "red" } }, "\u2466"),
                            " \uD31D\uC5C5 \uCC3D\uC774 \uB72C \uB4A4 \u2018\uD655\uC778\u2019 \uC744 \uD074\uB9AD\uD558\uBA74 \uC0AC\uC5C5\uC7A5\uC774 \uC0AD\uC81C\uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-3-4.png`)
                    }
                ]
            },
            {
                sid: 13,
                sname: "메시지 관리",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Checker 메시지, 에러 메세지, HTTP 메세지, 알람 메세지 항목 및 다국어 관리를 할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/7.Management/7-4-0.png`)
                    },
                    {
                        order: 2,
                        procedure: "e-Health Checker 메시지, 에러 메시지, HTTP 메시지, 알람 메시지 4가지 종류가 있습니다.\n     목록을 확인하고 추가/삭제가 가능합니다.",
                        captureImg: require(`/static/img/img_help/7.Management/7-4-1-1.png`)
                    },
                    {
                        order: 3,
                        procedure: "메시지 추가 시 이름과 종류를 추가 할 수 있고, 언어별의 따라 메시지를 추가 할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/7.Management/7-4-1-2.png`)
                    }
                ]
            },
            {
                sid: 14,
                sname: "메뉴 관리",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Portal 웹사이트 계정 유형별 메뉴 항목 활성화/비활성화, 다국어 관리를 할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/7.Management/7-5-0.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            "Admin, User, Engineer\uBCC4 \uC774\uC6A9 \uAD8C\uD55C\uC774 \uBD80\uC5EC\uB41C \uBA54\uB274\uB97C \uAD00\uB9AC\uD558\uB294 \uD398\uC774\uC9C0\uC785\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uBA54\uB274\uBCC4\uB85C \uBAA9\uB85D\uC744 \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uCD08\uAE30\uD654 : \uC124\uC815\uD558\uAE30 \uC804 \uCC98\uC74C \uC0C1\uD0DC\uB85C \uB3CC\uC544\uAC00\uB824\uBA74 \uCD08\uAE30\uD654\uB97C \uD074\uB9AD\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC218\uC815 : \uD074\uB9AD\uD558\uC5EC \uAD8C\uD55C\uC744 \uC218\uC815\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-5-1.png`)
                    },
                    {
                        order: 3,
                        procedure: React.createElement("span", null,
                            "\uB2E4\uAD6D\uC5B4 \uC124\uC815\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC5B8\uC5B4\uBCC4\uB85C \uC218\uC815\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-5-2.png`)
                    }
                ]
            },
            {
                sid: 15,
                sname: "Check Sheet 관리",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Check 서비스에서 제공하는 3단계 진단점검 항목의 버전 및 다국어 관리를 할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/7.Management/7-6-0.png`)
                    }
                ]
            },
            {
                sid: 16,
                sname: "Check Sheet 관리 - 목록",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "e-Health Check \uC11C\uBE44\uC2A4\uC5D0\uC11C \uC81C\uACF5\uD558\uB294 \uAE30\uAE30\uBCC4 \uC9C4\uB2E8\uC810\uAC80 \uD56D\uBAA9\uC758 \uBC84\uC804 \uBC0F \uB2E4\uAD6D\uC5B4 \uAD00\uB9AC \uBA54\uB274\uC785\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uD604\uC7AC \uB4F1\uB85D\uB41C \uAE30\uAE30\uC758 \uBC84\uC804\uC758 Check Sheet \uBAA9\uB85D\uC744 \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC810\uAC80\uB2E8\uACC4\uB294 \uC804\uCCB4, Basic. Premium, Advanced 4\uAC00\uC9C0\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uBC84\uC804\uC744 \uC120\uD0DD\uD558\uC5EC \uBCC0\uACBD\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uBC84\uC804\uC744 \uC218\uC815\uC744 \uD558\uACE0 \uC0C8\uB86D\uAC8C \uCD94\uAC00\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-6-1.png`)
                    }
                ]
            },
            {
                sid: 17,
                sname: "Check Sheet 관리 - 신규 버전 추가",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "e-Health Check \uC11C\uBE44\uC2A4\uC5D0\uC11C \uC81C\uACF5\uD558\uB294 \uAE30\uAE30\uBCC4 \uC9C4\uB2E8\uC810\uAC80 \uD56D\uBAA9\uC758 \uBC84\uC804 \uBC0F \uB2E4\uAD6D\uC5B4 \uAD00\uB9AC \uBA54\uB274\uC785\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2464"),
                            "  \uD31D\uC5C5 \uCC3D\uC774 \uB748 \uB2E4\uC74C \uBC84\uC804\uC744 \uC218\uC815\uC744 \uD558\uACE0 \uC0C8\uB86D\uAC8C \uCD94\uAC00\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-6-2-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            "e-Health Check \uC11C\uBE44\uC2A4\uC5D0\uC11C \uC81C\uACF5\uD558\uB294 \uAE30\uAE30\uBCC4 \uC9C4\uB2E8\uC810\uAC80 \uD56D\uBAA9\uC758 \uBC84\uC804 \uBC0F \uB2E4\uAD6D\uC5B4 \uAD00\uB9AC \uBA54\uB274\uC785\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            React.createElement("span", { style: { color: "red" } }, "\u2465"),
                            " \uD31D\uC5C5 \uCC3D\uC774 \uB2E4\uC2DC \uD55C \uBC88 \uB748 \uB2E4\uC74C \uD3B8\uC9D1\uD654\uBA74\uC73C\uB85C \uC774\uB3D9\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-6-2-2.png`)
                    }
                ]
            },
            {
                sid: 18,
                sname: "Check Sheet 관리 - 버전 관리",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "e-Health Check \uC11C\uBE44\uC2A4\uC5D0\uC11C \uC81C\uACF5\uD558\uB294 \uAE30\uAE30\uBCC4 \uC9C4\uB2E8\uC810\uAC80 \uD56D\uBAA9\uC758 \uBC84\uC804 \uBC0F \uB2E4\uAD6D\uC5B4 \uAD00\uB9AC \uBA54\uB274\uC785\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC810\uAC80\uB2E8\uACC4\uB294 \uC804\uCCB4, Basic. Premium, Advanced 4\uAC00\uC9C0\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC6D0\uD558\uB294 \uD56D\uBAA9\uC744 \uCD94\uAC00\uD558\uAC70\uB098 \uCD94\uAC00\uD55C \uD56D\uBAA9\uC744 \uC218\uC815\uD558\uC5EC \uC791\uC5C5 \uC644\uB8CC\uB97C \uD558\uC5EC \uBC84\uC804\uC744 \uCD94\uAC00 \uBC0F \uC218\uC815\uC744 \uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-6-3.png`)
                    }
                ]
            },
            {
                sid: 19,
                sname: "이메일 상담 관리",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Portal 웹사이트 사용자가 보낸 이메일 상담 리스트의 관리를 할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/7.Management/7-7-0.png`)
                    }
                ]
            },
            {
                sid: 20,
                sname: "이메일 상담 관리 - 목록",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "e-Health Portal \uC0AC\uC6A9\uC790\uAC00 \uBCF4\uB0B8 \uC774\uBA54\uC77C \uC0C1\uB2F4 \uB9AC\uC2A4\uD2B8\uC758 \uAD00\uB9AC\uC785\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uBB38\uC758 \uC720\uD615 \uBCC4\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC81C\uBAA9, \uBB38\uC758 \uB0B4\uC6A9, \uB2F5\uBCC0 \uBCC4\uB85C \uAC80\uC0C9 \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uB2F5\uBCC0\uD558\uAE30\uB97C \uB20C\uB7EC \uBB38\uC758\uC5D0 \uAD00\uD55C \uB2F5\uBCC0\uC744 \uB0A8\uAE38 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-7-1.png`)
                    }
                ]
            },
            {
                sid: 21,
                sname: "이메일 상담 관리 - 답변하기",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "e-Health Portal \uC0AC\uC6A9\uC790\uAC00 \uBCF4\uB0B8 \uC774\uBA54\uC77C \uC0C1\uB2F4 \uB9AC\uC2A4\uD2B8\uC758 \uAD00\uB9AC\uC785\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uB2F5\uBCC0 \uC791\uC131 \uBC0F \uCCA8\uBD80 \uD30C\uC77C\uC744 \uC791\uC131 \uD55C \uD6C4 \uC804\uC1A1\uC744 \uB20C\uB7EC \uB2F5\uBCC0\uD558\uAE30\uB97C \uB4F1\uB85D \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            "\uBB38\uC758 \uD588\uB358 \uC694\uCCAD\uC790\uC640 \uBB38\uC758 \uB0B4\uC6A9\uC774 \uD655\uC778\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-7-2.png`)
                    }
                ]
            },
            {
                sid: 22,
                sname: "이메일 상담 관리 - 답변완료",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "e-Health Portal \uC0AC\uC6A9\uC790\uAC00 \uBCF4\uB0B8 \uC774\uBA54\uC77C \uC0C1\uB2F4 \uB9AC\uC2A4\uD2B8\uC758 \uAD00\uB9AC\uC785\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2464"),
                            " \uB2F5\uBCC0 \uC644\uB8CC\uB97C \uD074\uB9AD\uD558\uC5EC \uB2F5\uBCC0 \uC815\uBCF4\uB97C \uD655\uC778 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-7-3.png`)
                    }
                ]
            },
            {
                sid: 23,
                sname: "이메일 상담 관리 - 상세정보",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            "e-Health Portal \uC0AC\uC6A9\uC790\uAC00 \uBCF4\uB0B8 \uC774\uBA54\uC77C \uC0C1\uB2F4 \uB9AC\uC2A4\uD2B8\uC758 \uAD00\uB9AC\uC785\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            React.createElement("span", { style: { color: "red" } }, "\u2465"),
                            " \uB2F5\uBCC0 \uC644\uB8CC\uB294 \uC815\uBCF4 \uD655\uC778\uB9CC \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/7.Management/7-7-4.png`)
                    }
                ]
            }
        ]
    },
    //   888   //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        "id": 8,
        "mname": "서비스 소개",
        "subMenu": [
            {
                sid: 1,
                sname: "서비스 둘러보기",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Portal의 대표적인 기능을 소개하는 페이지입니다.",
                        captureImg: require(`/static/img/img_help/8.Service Introduce/8-1-0.png`)
                    },
                    {
                        order: 2,
                        procedure: "e-Health Portal의 대표적인 기능인 대시보드, 진단점검, 운영관리, Report, 점검출동 등을 둘러볼 수 있습니다.",
                        captureImg: require(`/static/img/img_help/8.Service Introduce/8-1-1.png`)
                    }
                ]
            },
            {
                sid: 2,
                sname: "e-Health Portal 소개",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Portal 주요 서비스의 대한 설명을 하는 페이지 입니다.",
                        captureImg: require(`/static/img/img_help/8.Service Introduce/8-2-0.png`)
                    },
                    {
                        order: 2,
                        procedure: "e-Health Portal 주요 서비스인 메인대시보드, e-Health Check, Report, 설비수명, 운영관리, 점검이력/요청, 포탈 사용자에 대한 내용을 확인할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/8.Service Introduce/8-2-1.png`)
                    }
                ]
            },
            {
                sid: 3,
                sname: "도움말",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Portal 이용에 도움을 주는 도움말 페이지입니다.",
                        captureImg: require(`/static/img/img_help/8.Service Introduce/8-3-0.png`)
                    },
                    {
                        order: 2,
                        procedure: "좌측 목차 메뉴를 선택하면, 해당 도움말을 확인할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/8.Service Introduce/8-3-1.png`)
                    }
                ]
            }
        ]
    },
    //   999   //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        "id": 9,
        "mname": "서비스 요청",
        "subMenu": [
            {
                sid: 1,
                sname: "점검 출동 요청",
                snameContents: [
                    {
                        order: 1,
                        procedure: "LS ELECTRIC 제품의 대한 온라인 서비스를 신청이 가능합니다.",
                        captureImg: require(`/static/img/img_help/9.Service Request/9-1-0.png`)
                    }
                ]
            },
            {
                sid: 2,
                sname: "점검 출동 요청 - 온라인 문의",
                snameContents: [
                    {
                        order: 1,
                        procedure: "신청인 정보 및 제품 고장 내용을 입력 후 신청이 가능합니다.",
                        captureImg: require(`/static/img/img_help/9.Service Request/9-1-1.png`)
                    }
                ]
            },
            {
                sid: 3,
                sname: "Work Order",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Portal 사용자가 등록 및 관리하는 전력설비와 관련하여 LS ELECTRIC에서 과거부터 현재까지 진행된 점검이력 및 현재 요청에 대한 점검현황을 제공합니다.",
                        captureImg: require(`/static/img/img_help/9.Service Request/9-2-0.png`)
                    }
                ]
            },
            {
                sid: 4,
                sname: "Work Order - e-Health Check",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            "\uC0AC\uC6A9\uC790\uAC00 \uC18C\uC18D\uB41C \uD68C\uC0AC-\uC0AC\uC5C5\uC7A5\uC744 \uD074\uB9AD\uD558\uC5EC \uC870\uD68C\uB97C \uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/9.Service Request/9-2-1-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC0AC\uC6A9\uC790\uAC00 \uC18C\uC18D\uB41C \uD68C\uC0AC-\uC0AC\uC5C5\uC7A5\uC758 \uAE30\uC900 \uC810\uAC80\uC744 \uC0C1\uD0DC\uBCC4\uB85C \uAC80\uC0C9\uC774 \uAC00\uB2A5\uD558\uACE0 \uBAA9\uB85D\uC744 \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC0C1\uD0DC\uB294 \uC804\uCCB4, \uC694\uCCAD, \uC811\uC218, \uC9C4\uD589\uC911, \uC644\uB8CC\uAC00 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC694\uCCAD \uC77C\uC790 \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC77C\uC790\uB294 \uC804\uCCB4, 1\uAC1C\uC6D4, 3\uAC1C\uC6D4, 6\uAC1C\uC6D4 1\uB144\uC774 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uAC80\uC0C9 \uC870\uAC74 \uAC80\uC0C9\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC870\uAC74\uC740 \uAE30\uAE30 \uBA85, \uD328\uB110 \uBA85, \uC2DC\uB9AC\uC5BC \uBC88\uD638, \uBAA8\uB378 \uBA85\uC73C\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/9.Service Request/9-2-1-2.png`)
                    }
                ]
            },
            {
                sid: 5,
                sname: "Work Order - 점검출동",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC810\uAC80\uCD9C\uB3D9\uC744 \uC0C1\uD0DC\uBCC4\uB85C \uAC80\uC0C9\uC774 \uAC00\uB2A5\uD558\uACE0 \uBAA9\uB85D\uC744 \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC0C1\uD0DC\uB294 \uC804\uCCB4, \uC694\uCCAD, \uC811\uC218, \uC9C4\uD589\uC911, \uC644\uB8CC\uAC00 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC694\uCCAD \uC77C\uC790 \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC77C\uC790\uB294 \uC804\uCCB4, 1\uAC1C\uC6D4, 3\uAC1C\uC6D4, 6\uAC1C\uC6D4 1\uB144\uC774 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uAC80\uC0C9 \uC870\uAC74 \uAC80\uC0C9\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            "\uC870\uAC74\uC740 \uAE30\uAE30 \uBA85, \uBD88\uB7C9\uC6D0\uC778, \uBD88\uB7C9\uCC98\uB9AC, \uC2DC\uB9AC\uC5BC \uBC88\uD638, \uBAA8\uB378 \uBA85\uC73C\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/9.Service Request/9-2-2.png`)
                    }
                ]
            },
            {
                sid: 6,
                sname: "Work Order - 점검/사고이력",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC810\uAC80 \uBC0F \uC0AC\uACE0\uC774\uB825\uC744 \uC0C1\uD0DC\uBCC4\uB85C \uAC80\uC0C9\uC774 \uAC00\uB2A5\uD558\uACE0 \uBAA9\uB85D\uC744 \uC870\uD68C \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC0C1\uD0DC\uB294 \uC804\uCCB4, \uC694\uCCAD, \uC811\uC218, \uC9C4\uD589\uC911, \uC644\uB8CC\uAC00 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uC694\uCCAD \uC77C\uC790 \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC77C\uC790\uB294 \uC804\uCCB4, 1\uAC1C\uC6D4, 3\uAC1C\uC6D4, 6\uAC1C\uC6D4 1\uB144\uC774 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uAC80\uC0C9 \uC870\uAC74 \uAC80\uC0C9\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            "\uC870\uAC74\uC740 \uAE30\uAE30 \uBA85, \uBD88\uB7C9\uC6D0\uC778, \uBD88\uB7C9\uCC98\uB9AC, \uC2DC\uB9AC\uC5BC \uBC88\uD638, \uBAA8\uB378 \uBA85\uC73C\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/9.Service Request/9-2-3.png`)
                    }
                ]
            },
            {
                sid: 7,
                sname: "Work Order - 노후교체 컨설팅",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            " \uC0AC\uC5C5\uC7A5 \uBC0F \uC0C1\uC138 \uC0AC\uC5C5\uC7A5 \uC120\uD0DD \uD6C4 ",
                            React.createElement("span", { style: { color: "red" } }, "\u2461"),
                            " \uB178\uD6C4\uAD50\uCCB4 \uC0C1\uD0DC\uC758 \uB530\uB77C \uC694\uCCAD \uBAA9\uB85D \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC0C1\uD0DC\uB294 \uC804\uCCB4, \uC694\uCCAD, \uC811\uC218\uAC00 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2462"),
                            " \uC694\uCCAD \uC77C\uC790 \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC77C\uC790\uB294 \uC804\uCCB4, 1\uAC1C\uC6D4, 3\uAC1C\uC6D4, 6\uAC1C\uC6D4 1\uB144\uC774 \uC788\uC2B5\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "     ",
                            React.createElement("span", { style: { color: "red" } }, "\u2463"),
                            " \uAC80\uC0C9 \uC870\uAC74 \uAC80\uC0C9\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4.",
                            React.createElement("br", null),
                            "          ",
                            "\u279C",
                            " \uC870\uAC74\uC740 \uAE30\uAE30 \uBA85, \uD328\uB110 \uBA85, \uC2DC\uB9AC\uC5BC \uBC88\uD638, \uBAA8\uB378 \uBA85\uC73C\uB85C \uC870\uD68C\uAC00 \uAC00\uB2A5\uD569\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/9.Service Request/9-2-4.png`)
                    }
                ]
            },
            {
                sid: 8,
                sname: "이메일 상담",
                snameContents: [
                    {
                        order: 1,
                        procedure: "e-Health Portal 웹사이트 사용 및 기타 문의내용을 이메일 상담하는 기능을 제공합니다.",
                        captureImg: require(`/static/img/img_help/9.Service Request/9-3-0.png`)
                    }
                ]
            },
            {
                sid: 9,
                sname: "이메일 상담 - 요청",
                snameContents: [
                    {
                        order: 1,
                        procedure: "상담입력(제목, 문의 유형, 내용) 및 첨부파일을 하여 이메일 상담을 요청 할 수 있습니다.",
                        captureImg: require(`/static/img/img_help/9.Service Request/9-3-1-1.png`)
                    }
                ]
            },
            {
                sid: 10,
                sname: "이메일 상담 - 서비스 센터",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            "\uC744 \uD074\uB9AD\uD558\uBA74 \uC11C\uBE44\uC2A4\uC13C\uD130 \uC548\uB0B4 \uD398\uC774\uC9C0\uB85C \uC774\uB3D9\uD558\uAC8C \uB429\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/9.Service Request/9-3-2-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null, "LS Electric \uC11C\uBE44\uC2A4 \uC13C\uD130\uB97C \uCC3E\uC544 \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/9.Service Request/9-3-2-2.png`)
                    }
                ]
            },
            {
                sid: 11,
                sname: "이메일 상담 - 챗봇",
                snameContents: [
                    {
                        order: 1,
                        procedure: React.createElement("span", null,
                            React.createElement("span", { style: { color: "red" } }, "\u2460"),
                            "\uC744 \uD074\uB9AD\uD558\uBA74 \uCC57\uBD07 \uC11C\uBE44\uC2A4\uB97C \uC0AC\uC6A9 \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/9.Service Request/9-3-3-1.png`)
                    },
                    {
                        order: 2,
                        procedure: React.createElement("span", null, "LS Electric \uC5C5\uBB34\uC5D0 \uB300\uD55C \uBB38\uC758\uB97C \uCC57\uBD07\uC744 \uD1B5\uD574 \uBE60\uB974\uAC8C \uC548\uB0B4\uB97C \uBC1B\uC744 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                        captureImg: require(`/static/img/img_help/9.Service Request/9-3-3-2.png`)
                    }
                ]
            }
        ]
    }
];
